import React, { useState } from "react";
import GetWindowSize from "../../../hooks/general/GetWindowSize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import GetCSFR from "../../../hooks/userAuthentication/GetCSFR";
import LoadingAnimation from "../LoadingAnimation";

interface Props {
    displayForm:(value:boolean) => void
}

export default function AddCoach({displayForm}:Props){
    const csrfToken = GetCSFR({ name: "csrftoken" })
    const windowSize = GetWindowSize()
    const [insideForm, setInsideForm] = useState<boolean>(false)
    const [coachEmail, setCoachEmail] = useState<string>("")
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null);


    // Close the form if user clicks outside of it
    function handleExit(value:boolean){
        if(!insideForm){
            displayForm(value)
        }
    }

    function addCoachToClub(e: React.FormEvent) {
        e.preventDefault()

        if (!coachEmail) return;

        setSubmitting(true)
        setError(null)

        axios.post(`${process.env.REACT_APP_SKILLJA_URL}/auth/club/add_coach/`, { email: coachEmail }, {
                headers: {
                    "X-CSRFToken": csrfToken,
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
            )
            .then((res) => {
                if(res.status===200){
                    displayForm(false)
                }
                else if(res.status===204){
                    alert('This email address is already part of your club!')
                }
            })
            .catch(() => { setError("Unable to send invite. Please try again.")})
            .finally(() => setSubmitting(false))
    }

    return (
        <div className="pop-up-background" 
            onClick={windowSize.width >=1024 ? 
                ()=>handleExit(false) 
            : 
                undefined
            }
        > 
            <div 
                className="pop-up-container h-2/5"
                onMouseEnter={()=>setInsideForm(true)} 
                onMouseLeave={()=>setInsideForm(false)}
            >
                <div className="grid grid-cols-3 grid-rows-1 p-5 px-7 lg:px-10 bg-main-white rounded-t-xl">
                    <FontAwesomeIcon 
                        icon={faX}
                        className="text-main-green-900 hover:text-main-green-500 mr-auto my-auto cursor-pointer"
                        onClick={()=>handleExit(false)}
                        onMouseEnter={()=>setInsideForm(false)}
                    />
                </div>
                {submitting ?
                    <div className="mt-10">
                        <LoadingAnimation />
                    </div>
                :
                    <form className="flex flex-col items-center" onSubmit={addCoachToClub}>
                        <h2 className="text-center mx-auto font-medium text-lg px-3">
                            Invite a coach to your Club!
                        </h2>
                        <input 
                            type="email"
                            className="form-input px-3.5 py-2.5 mt-4 mb-8 w-60"
                            onChange={(e)=>setCoachEmail(e.target.value)}
                            pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                            required
                            placeholder="Enter Coach Email"
                        />
                        {error && (
                            <p className="text-sm text-red-500 mb-4">
                                {error}
                            </p>
                        )}
                        <button type="submit" className="form-btn text-base px-4 py-2 mt-auto">
                            Invite Coach
                        </button>
                    </form>
                }
            </div>
        </div>
    )
}